export default function({language, validators}) {

    var config = {
        label: language["email-label"],
        placeholder: language["email-placeholder"],
        autoComplete: "email",
        format: "email",
        api: {
            errorMessage: language["email-does-not-exist"]
        },
        validators: ["mandatory", "email"]
    };

    return {
        config: config,
        validators: [
            validators.mandatory(),
            validateEmail(validators)
        ],
        extendsType: 'text-field'
    };

    function validateEmail({matches}) {
        const emailRegexDotCom = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        const customSimpleRegex = /^.+@.+\.[a-z]+/i;

        return matches(customSimpleRegex, language["email-invalid"]);
    }

};
